import {React,useState,useEffect} from "react";
import {toast} from 'react-toastify'
import { useSelector } from "react-redux";
import {useHistory} from 'react-router-dom'
import ReactLoading from 'react-loading';
import 'react-dropdown/style.css';

import './EquipmentShow.scss'
import Product from '../Product/Product';
import { getData } from "../Services/APIService";
import config from "../Services/config.json";
import JButton from '../../components/Button/JButton';

const EquipmentShow= ({serviceType}) => {
    const history = useHistory();
    const customer = useSelector(state => state.customer);

    const [getItems,setItems] = useState([]);
    const [getIndex,setIndex] = useState(0);
    const [getAll,setAll] = useState(0);
    const [getLoading,setLoading] = useState(true);
    const [getLoadingMore,setLoadingMore] = useState(false);

    useEffect( () => {
        // if(customer.serviceType != 1)
        //     history.push("/");
        // else
            handleLoadInfo();
   },[]);

    //####################################################################

    const handleLoadMore = async () =>{
        setLoadingMore(true);
        handleLoadInfo();
        setLoadingMore(false);
    }
    
    const handleLoadInfo = async () =>{
        
        setLoading(true);

        let index=getIndex+1;
        setIndex(index);

        const info={
            token: config.APIKey,
            tag: 0,
            type: 1,
            category:0,
            duration:-10,
            traffic:-10,
            speed:-10,
            modem: 1,
            index:index,
            size:5,
            selectedService:0
         };

        try{
            const {data}=await getData('store/getPackages',info);
            
            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                //toast.error("خطایی رخ داده است",{position:'bottom-left',closeButton:true,closeOnClick:true});
                console.log("StoreError: ","خطایی رخ داده است");
            }
            else{
                setItems(getItems.concat(data.packages));
                setAll(data.all);
            }
        }
        catch(ex){
            // toast.error("مشکلی پیش آمده.", {
            //     position: "bottom-left",
            //     closeOnClick: true
            // });
            console.log("StoreError: ",ex.Message);
        }

        setLoading(false);
    }
    
    return (
        <div>
                <div className="selectServiceTitle">
                    <label>انتخاب تجهیزات</label>
                    <span className="fa fa-wifi"></span>       
                </div>
                {getItems.length>0 ? 
                <>
                    <div className="items">
                        {getLoading ? <ReactLoading type="bubbles" color={"#ff8035"} height={150} width={120} className="reactLoading" /> : null}
                        {getItems.map(item => (
                        <div className="oneProduct">
                            <Product
                                code={item.code}
                                productImage={item.tag != 3 ? item.images[0] : item.images[2]}
                                serviceType={item.serviceType}
                                title1={item.description[0]}
                                title2={item.description[1]}
                                title3={item.description[2]}
                                title4={item.description[3]}
                                title5={item.description[4]}
                                title6={item.description[5]}
                                mainPrice={item.mainPrice}
                                discountPrice={item.discountPrice}
                                canSelect={true}
                                selected={item.code=== customer.serviceCode ? true : false}
                                productDes={item.productDes}
                                isEquipment={true}
                            />
                        </div>))}
                    </div>
                    {getAll > (getIndex*5) ?
                    <div className="loadMore">
                        {/* <div className="btnLoadMore" onClick={() => handleLoadMore()}>
                            {
                                !getLoadingMore ?
                                <>
                                <span className="fa fa-download"></span>
                                <label>مشاهده بیشتر</label>
                                </>
                                :
                                <ReactLoading type="bubbles" color={"#ff8035"} className="reactLoadingMore" />
                            }
                        </div> */}
                        <div className="btnLoadMore">
                            <JButton handleClick={handleLoadMore} title={!getLoadingMore ? "مشاهده بیشتر" : <ReactLoading type="bubbles" color={"#ff8035"} className="reactLoadingMore" />} rightIcon={"fa fa-download"} type={""} noSize={true}/>
                        </div>
                    </div>
                    :null}
                </> :
                serviceType === 1 ? <div className="notFoundItems">موردی یافت نشد</div> : null
            }
        </div>
     );
}

export default EquipmentShow;